module.exports = __webpack_public_path__ + "static/img/bearx.6dafa56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partnerships/bearx.png
// module id = 1oGx
// module chunks = 1